export default {
  header: 'Leave page with unsaved changes?',
  message: 'Leaving this page will delete all unsaved changes.',
  leavePage: 'Leave page',
  stay: 'Stay',
};
